import React, { useState } from 'react';
import { FiChevronDown, FiEye, FiEyeOff, FiLock, FiMail } from 'react-icons/fi';
import api from './Services/api';
import endpointsAdmin from './Services/endpointAdmin';
import useAPI from './hooks/useAPI';

function getLembagaValue(item) {
  return String(item?.id_lembaga || item?.id || '').trim();
}

function getLembagaLabel(item) {
  return String(item?.nama_lembaga || item?.nama || getLembagaValue(item)).trim();
}

function getKodeHimpunFromAdmin(adminData) {
  if (!adminData) return null;
  if (adminData.kode_himpun) return adminData.kode_himpun;
  if (adminData.himpun?.kode_himpun) return adminData.himpun.kode_himpun;
  if (Array.isArray(adminData.himpun) && adminData.himpun[0]?.kode_himpun) {
    return adminData.himpun[0].kode_himpun;
  }
  if (adminData.user?.kode_himpun) return adminData.user.kode_himpun;
  if (adminData.data?.kode_himpun) return adminData.data.kode_himpun;
  return null;
}

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(135deg, #0a1628 0%, #0f2a52 50%, #1a3a6e 100%)',
    padding: '1rem',
    fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    maxWidth: '960px',
    minHeight: '420px',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0 32px 100px rgba(0,0,0,0.5)',
  },
  leftPanel: {
    width: '320px',
    flexShrink: 0,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '2.5rem 2rem',
    overflow: 'hidden',
  },
  leftBg: {
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
  },
  leftOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(to bottom, rgba(5,15,40,0.55) 0%, rgba(5,15,40,0.25) 50%, rgba(5,15,40,0.6) 100%)',
  },
  leftContent: {
    position: 'relative',
    zIndex: 2,
    textAlign: 'center',
    color: '#fff',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  leftLogo: {
    width: '600px',
    height: '600px',
    objectFit: 'contain',
    filter: 'drop-shadow(0 8px 24px rgba(0,0,0,0.35))',
  },
  logoCard: {
    background: 'rgba(255,255,255,0.18)',
    backdropFilter: 'blur(12px)',
    WebkitBackdropFilter: 'blur(12px)',
    border: '1px solid rgba(255,255,255,0.35)',
    borderRadius: '14px',
    width: '140px',
    height: '48px',
    marginTop: '7rem',
    boxShadow: '0 8px 32px rgba(0,0,0,0.25)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'visible',
    position: 'relative',
  },
  leftTitle: {
    fontSize: '1rem',
    fontWeight: 700,
    color: '#fff',
    letterSpacing: '-0.01em',
    textShadow: '0 2px 12px rgba(0,0,0,0.4)',
  },
  leftSubtitle: {
    fontSize: '0.85rem',
    color: 'rgba(255,255,255,0.75)',
    margin: 0,
    lineHeight: 1.6,
  },
  bySection: {
    position: 'absolute',
    bottom: '1.5rem',
    left: 0,
    right: 0,
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
  },
  byLabel: {
    fontSize: '0.7rem',
    color: 'rgba(255,255,255,0.6)',
    fontWeight: 500,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
  },
  byLogo: {
    height: '22px',
    width: 'auto',
    objectFit: 'contain',
  },
  leftBadge: {
    display: 'inline-block',
    marginBottom: '0.75rem',
    padding: '0.25rem 0.9rem',
    borderRadius: '999px',
    background: 'rgba(245,158,11,0.18)',
    border: '1px solid rgba(245,158,11,0.45)',
    color: '#fcd34d',
    fontSize: '0.7rem',
    fontWeight: 600,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
  },
  rightPanel: {
    flex: 1,
    background: '#fff',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    padding: '2.25rem 2.5rem',
  },
  rightHeader: {
    marginBottom: '1.75rem',
  },
  rightTag: {
    fontSize: '0.7rem',
    fontWeight: 700,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: '#f59e0b',
    marginBottom: '0.5rem',
  },
  rightTitle: {
    fontSize: '1.55rem',
    fontWeight: 700,
    color: '#0f172a',
    margin: '0 0 0.35rem',
    letterSpacing: '-0.02em',
  },
  rightDesc: {
    fontSize: '0.82rem',
    color: '#64748b',
    lineHeight: 1.65,
    margin: 0,
  },
  divider: {
    height: '1px',
    background: 'linear-gradient(to right, transparent, #e2e8f0, transparent)',
    margin: '0 0 1.5rem',
  },
  errorBox: {
    marginBottom: '1rem',
    padding: '0.75rem 1rem',
    borderRadius: '10px',
    border: '1px solid #fecaca',
    background: '#fef2f2',
    color: '#b91c1c',
    fontSize: '0.82rem',
    lineHeight: 1.55,
  },
  formGroup: {
    marginBottom: '1rem',
  },
  label: {
    display: 'block',
    fontSize: '0.8rem',
    fontWeight: 600,
    color: '#334155',
    marginBottom: '0.45rem',
  },
  inputWrap: {
    position: 'relative',
  },
  inputIcon: {
    position: 'absolute',
    left: '14px',
    top: '50%',
    transform: 'translateY(-50%)',
    color: '#94a3b8',
    pointerEvents: 'none',
    width: '17px',
    height: '17px',
  },
  input: {
    width: '100%',
    padding: '0.78rem 1rem 0.78rem 2.75rem',
    border: '1.5px solid #e2e8f0',
    borderRadius: '10px',
    fontSize: '0.875rem',
    color: '#0f172a',
    background: '#f8fafc',
    outline: 'none',
    transition: 'border-color 0.18s, box-shadow 0.18s, background 0.18s',
    boxSizing: 'border-box',
  },
  eyeBtn: {
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    width: '44px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#94a3b8',
    transition: 'color 0.15s',
    padding: 0,
  },
  submitBtn: {
    marginTop: '0.5rem',
    width: '100%',
    height: '48px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.5rem',
    borderRadius: '10px',
    border: 'none',
    background: 'linear-gradient(135deg, #0f172a 0%, #1e3a8a 65%, #f59e0b 160%)',
    color: '#fff',
    fontSize: '0.9rem',
    fontWeight: 600,
    cursor: 'pointer',
    transition: 'transform 0.18s, box-shadow 0.18s, opacity 0.18s',
    boxShadow: '0 4px 20px rgba(30,58,138,0.35)',
    letterSpacing: '0.01em',
  },
  infoBox: {
    marginTop: '1.25rem',
    padding: '0.75rem 1rem',
    borderRadius: '10px',
    background: '#fffbeb',
    border: '1px solid #fde68a',
    textAlign: 'center',
  },
  infoText: {
    fontSize: '0.75rem',
    color: '#78716c',
    lineHeight: 1.6,
    margin: 0,
  },
};

function Login({ onAdminLogin }) {
  const { data: lembagaData, loading: loadingLembaga } = useAPI(endpointsAdmin.lembaga.getAll);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [selectedLembagaId, setSelectedLembagaId] = useState('');
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  const lembagaList = Array.isArray(lembagaData)
    ? lembagaData
    : Array.isArray(lembagaData?.lembaga)
      ? lembagaData.lembaga
      : Array.isArray(lembagaData?.data)
        ? lembagaData.data
        : Array.isArray(lembagaData?.result)
          ? lembagaData.result
          : [];

  const handleLogin = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);

    if (!selectedLembagaId) {
      setError('Pilih lembaga admin terlebih dahulu.');
      setIsLoading(false);
      return;
    }

    const selectedLembaga = lembagaList.find(
      (item) => getLembagaValue(item) === String(selectedLembagaId || '').trim()
    );

    try {
      const adminLoginEndpoint = endpointsAdmin.users.loginAdminmitraByLembaga(selectedLembagaId);
      let responseAdmin;

      try {
        responseAdmin = await api.post(adminLoginEndpoint, {
          email,
          password,
        });
      } catch (adminMitraError) {
        const status = adminMitraError.response?.status;
        const shouldFallbackToGenericLogin = status === 404 || status === 400;

        if (!shouldFallbackToGenericLogin) {
          throw adminMitraError;
        }

        responseAdmin = await api.post(endpointsAdmin.users.login, {
          email,
          password,
        });
      }

      const adminData = responseAdmin.data;
      const kodeHimpun = getKodeHimpunFromAdmin(adminData);

      const storedAdmin = {
        ...adminData,
        ...(kodeHimpun ? { kode_himpun: kodeHimpun } : {}),
        ...(selectedLembaga
          ? {
              selected_id_lembaga: getLembagaValue(selectedLembaga),
              selected_nama_lembaga: getLembagaLabel(selectedLembaga),
            }
          : {}),
      };

      localStorage.setItem('admin_user', JSON.stringify(storedAdmin));
      if (onAdminLogin) {
        onAdminLogin(storedAdmin);
      }
    } catch (err) {
      const status = err.response?.status;
      const is404 = status === 404;
      let message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        err.message ||
        'Login admin gagal. Periksa kembali data Anda.';
      if (is404 && !err.response?.data?.message && err.config?.url?.includes('/api/users/login/adminmitra')) {
        message =
          'Endpoint login admin mitra (/api/users/login/adminmitra/:id_lembaga) tidak ditemukan (404). Pastikan backend sudah aktif.';
      }
      setError(message);
    } finally {
      setIsLoading(false);
    }
  };

  const getInputStyle = (fieldName) => ({
    ...styles.input,
    borderColor: focusedField === fieldName ? '#f59e0b' : '#e2e8f0',
    boxShadow: focusedField === fieldName ? '0 0 0 3px rgba(245,158,11,0.15)' : 'none',
    background: focusedField === fieldName ? '#fff' : '#f8fafc',
  });

  return (
    <>
      <style>{`
        @keyframes fadeSlideIn {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .login-card { animation: fadeSlideIn 0.55s cubic-bezier(.22,.68,0,1.2) both; }
        .login-submit-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 8px 28px rgba(30,58,138,0.45);
        }
        .login-submit-btn:disabled { opacity: 0.65; cursor: not-allowed; }
        @media (max-width: 700px) {
          .login-left-panel { display: none !important; }
          .login-right-panel { width: 100% !important; padding: 2rem 1.5rem !important; }
        }
      `}</style>

      <div style={styles.page}>
        <div className="login-card" style={styles.card}>

          {/* ── Left Panel ── */}
          <div className="login-left-panel" style={styles.leftPanel}>
            <img src="/bg_mpzdt1.png" alt="MITRA PENGELOLA ZAKAT" style={styles.leftBg} />
            <div style={styles.leftOverlay} />
            <div style={styles.leftContent}>
              <div style={styles.leftBadge}>Admin Portal</div>
              <div style={styles.logoCard}>
                <img src="/logo_mpzdt.png" alt="Logo MPZ DT" style={styles.leftLogo} />
              </div>
              <h2 style={styles.leftTitle}>MITRA PENGELOLA ZAKAT</h2>
              <p style={styles.leftSubtitle}>
                Muzakki Zakat &amp; Infak<br />Dompet Dhuafa Dakwah Terpadu
              </p>
            </div>
            {/* ── By Section ── */}
            <div style={styles.bySection}>
              <span style={styles.byLabel}>By :</span>
              <img src="/logo_dpudt.png" alt="DT Peduli" style={styles.byLogo} />
            </div>
          </div>

          {/* ── Right Panel ── */}
          <div className="login-right-panel" style={styles.rightPanel}>
            <div style={styles.rightHeader}>
              <p style={styles.rightTag}>Login Admin</p>
              <h1 style={styles.rightTitle}>Selamat Datang</h1>
              <p style={styles.rightDesc}>
                Masukkan email, password, dan lembaga Anda untuk mengakses dashboard.
              </p>
            </div>

            <div style={styles.divider} />

            {error && (
              <div style={styles.errorBox}>{error}</div>
            )}

            <form onSubmit={handleLogin}>
              {/* Email */}
              <div style={styles.formGroup}>
                <label htmlFor="email" style={styles.label}>Email</label>
                <div style={styles.inputWrap}>
                  <FiMail style={styles.inputIcon} aria-hidden="true" />
                  <input
                    id="email"
                    type="email"
                    placeholder="Masukkan email Anda"
                    style={getInputStyle('email')}
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    onFocus={() => setFocusedField('email')}
                    onBlur={() => setFocusedField(null)}
                    required
                  />
                </div>
              </div>

              {/* Password */}
              <div style={styles.formGroup}>
                <label htmlFor="password" style={styles.label}>Password</label>
                <div style={styles.inputWrap}>
                  <FiLock style={styles.inputIcon} aria-hidden="true" />
                  <input
                    id="password"
                    type={showPassword ? 'text' : 'password'}
                    placeholder="Masukkan password Anda"
                    style={{ ...getInputStyle('password'), paddingRight: '44px' }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    onFocus={() => setFocusedField('password')}
                    onBlur={() => setFocusedField(null)}
                    required
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={styles.eyeBtn}
                    aria-label={showPassword ? 'Sembunyikan password' : 'Tampilkan password'}
                  >
                    {showPassword ? <FiEyeOff size={17} /> : <FiEye size={17} />}
                  </button>
                </div>
              </div>

              {/* Lembaga */}
              <div style={styles.formGroup}>
                <label htmlFor="lembaga" style={styles.label}>Lembaga</label>
                <div style={styles.inputWrap}>
                  <select
                    id="lembaga"
                    value={selectedLembagaId}
                    onChange={(e) => setSelectedLembagaId(e.target.value)}
                    onFocus={() => setFocusedField('lembaga')}
                    onBlur={() => setFocusedField(null)}
                    disabled={loadingLembaga}
                    style={{
                      ...getInputStyle('lembaga'),
                      paddingLeft: '1rem',
                      paddingRight: '2.5rem',
                      appearance: 'none',
                      WebkitAppearance: 'none',
                    }}
                  >
                    <option value="">
                      {loadingLembaga ? 'Memuat daftar lembaga...' : 'Pilih lembaga admin'}
                    </option>
                    {lembagaList.map((item) => (
                      <option key={getLembagaValue(item)} value={getLembagaValue(item)}>
                        {getLembagaLabel(item)}
                      </option>
                    ))}
                  </select>
                  <FiChevronDown
                    style={{ ...styles.inputIcon, left: 'auto', right: '14px', pointerEvents: 'none' }}
                    aria-hidden="true"
                  />
                </div>
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={isLoading}
                className="login-submit-btn"
                style={styles.submitBtn}
              >
                {isLoading ? (
                  <>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" style={{ animation: 'spin 0.8s linear infinite' }}>
                      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
                      <circle cx="12" cy="12" r="10" stroke="rgba(255,255,255,0.3)" strokeWidth="3" />
                      <path d="M12 2a10 10 0 0 1 10 10" stroke="#fff" strokeWidth="3" strokeLinecap="round" />
                    </svg>
                    Memproses...
                  </>
                ) : (
                  'Masuk ke Akun'
                )}
              </button>
            </form>

            <div style={styles.infoBox}>
              <p style={styles.infoText}>
                Akses hanya untuk akun admin yang sudah terdaftar dan memiliki lembaga aktif.
              </p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default Login;
